import {
  initiateLogin,
  storeTokens,
  clearTokens,
  getAccessToken,
  logout as ssoLibLogout,
  type SsoTokenResponse,
} from '@nota/sso';
import { getSsoConfig } from '../config/ssoConfig';

const SSO_SESSION_KEY = 'sso_session';
const SSO_FROM_PATH_KEY = 'sso.from_path';

export const bridgeTokens = (): void => {
  const ssoToken = getAccessToken();
  if (ssoToken) {
    localStorage.setItem('access_token', ssoToken);
  }
  localStorage.setItem(SSO_SESSION_KEY, 'true');
};

export const initiateSsoLogin = async (from?: string): Promise<void> => {
  const config = getSsoConfig();

  if (from) {
    sessionStorage.setItem(SSO_FROM_PATH_KEY, from);
  }

  const authUrl = await initiateLogin(config);
  window.location.href = authUrl;
};

export const isSsoSession = (): boolean => {
  return localStorage.getItem(SSO_SESSION_KEY) === 'true';
};

export const clearSsoSession = (): void => {
  clearTokens();
  localStorage.removeItem(SSO_SESSION_KEY);
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('token_expiry');
  localStorage.removeItem('user');
};

export const refreshSsoTokens = async (): Promise<string> => {
  const config = getSsoConfig();
  const refreshToken = localStorage.getItem('refreshToken');

  if (!refreshToken) {
    throw new Error('No SSO refresh token available');
  }

  const body = new URLSearchParams({
    grant_type: 'refresh_token',
    refresh_token: refreshToken,
    client_id: config.clientId,
    resource: config.resource,
  });

  const response = await fetch(`${config.authority}/token`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body,
  });

  if (!response.ok) {
    throw new Error(`SSO token refresh failed: ${response.status}`);
  }

  const tokenResponse: SsoTokenResponse = await response.json();
  storeTokens(tokenResponse);
  bridgeTokens();

  return tokenResponse.access_token;
};

export const ssoLogout = (): void => {
  const config = getSsoConfig();
  ssoLibLogout(config);
  localStorage.removeItem(SSO_SESSION_KEY);
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('token_expiry');
  localStorage.removeItem('user');
};

export const consumeFromPath = (): string | null => {
  const from = sessionStorage.getItem(SSO_FROM_PATH_KEY);
  if (from) {
    sessionStorage.removeItem(SSO_FROM_PATH_KEY);
  }
  return from;
};
